//************************************************************************ /
// CARD AVATAR HEADER
// Header component for story cards, displaying the author's avatar,
// username, and post date.
//************************************************************************ /

import React from "react";
import {
  Avatar,
  Group,
  Typography,
} from "@dreambigger/design-system/src/components";
import { generateCloudinaryUrl } from "../../../../utils";
import { calculateTimePast } from "../../../../dates/calculate-days-past";

const { Title, Text } = Typography;

export interface CardAvatarHeaderProps {
  user: any;
  font?: string;
  timestamp: string;
  onClick?: React.MouseEventHandler;
}

const CardAvatarHeader = ({
  user,
  font = "proxima-nova",
  timestamp,
  onClick,
}: CardAvatarHeaderProps) => {
  const userInitials = (
    (user?.firstName[0] ?? "") + (user?.lastName[0] ?? "")
  ).toUpperCase();

  const hasStoryUserImage =
    user?.imageId &&
    user?.imageVersion &&
    // We don't want to use the default avatar image that is saved to users.
    user?.imageId !== "avatar";

  return (
    <Group
      xs="horizontal"
      spacing={3}
      className="ph-5 pv-4 items-center"
      onClick={onClick}
    >
      {/* Avatar */}
      <Avatar
        size="large"
        alt="story user avatar"
        src={
          hasStoryUserImage &&
          generateCloudinaryUrl(user.imageVersion, user.imageId, {
            type: "avatar",
          })
        }
      >
        {!hasStoryUserImage && userInitials}
      </Avatar>
      <Group>
        {/* Author Name */}
        <Title level={5} style={{ fontFamily: font }}>
          {user.firstName} {user.lastName}
        </Title>
        {/* Post Date */}
        <Text type="secondary" className="f-2" style={{ fontFamily: font }}>
          {calculateTimePast(new Date(timestamp))}
        </Text>
      </Group>
    </Group>
  );
};
export default CardAvatarHeader;
